export interface SectionActionTypes {
  type: SectionActions;
  payload?: any;
}

export enum SectionActions {
  GET_SECTION_LIST = "GET_SECTION_LIST",
  SET_SECTION_LIST = "SET_SECTION_LIST",
  SET_SECTION_PAGE_COUNT = "SET_SECTION_PAGE_COUNT",
  ADD_SECTION = "ADD_SECTION",
}
